import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, NodeManagerModelState } from '@/models/connect';
import {
  OnActiveAction,
  OnChangeThemeAction,
  OnMount_Page_Action,
  OnMount_ThemePage_Action,
  OnUnmount_ThemePage_Action,
  FetchThemesAction,
  ChangeAction,
} from '@/models/nodeManagerPage';
import { history, useParams } from 'umi';
import FNoDataTip from '@/components/FNoDataTip';
import FLoadingTip from '@/components/FLoadingTip';
import FLeftSiderLayout from '@/layouts/FLeftSiderLayout';
import Sider from '../Sider';
import FTooltip from '@/components/FTooltip';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FCoverImage from '@/components/FCoverImage';
import { Helmet } from 'react-helmet';
import FCoverFooterButtons from '@/components/FCoverFooterButtons';
import fMessage from '@/components/fMessage';
import FComponentsLib from '@freelog/components-lib';
// import { LoadingOutlined } from '@ant-design/icons';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import FIcons from '@/components/FIcons';
import RecommendThemes from '@/components/FRecommendThemes';
import FInput_Search from '@/components/FInput_Search';

interface ThemesProps {
  dispatch: Dispatch;
  nodeManagerPage: NodeManagerModelState;
}

function Themes({ dispatch, nodeManagerPage }: ThemesProps) {
  const params = useParams();
  const id = params.id ?? '';
  // const [themeList, setThemeList] = React.useState<any[]>([]);
  // const [emptyTheme, setEmptyTheme] = React.useState<any>(null);
  const [activeId, setActiveId] = React.useState<null | string>(null);
  const [emptyPopupShow, setEmptyPopupShow] = React.useState(false);

  const [themeInputFilter, setThemeInputFilter] = React.useState<string>('');

  AHooks.useMount(async () => {
    dispatch<OnMount_ThemePage_Action>({
      type: 'nodeManagerPage/onMount_ThemePage',
    });

    // const [themeList, emptyThemeList] = await Promise.all([
    //   FServiceAPI.Resource.resourcesRecommend({ recommendType: 1 }),
    //   FServiceAPI.Resource.resourcesRecommend({ recommendType: 2 }),
    // ]);
    // setThemeList(themeList.data);
    // setEmptyTheme(emptyThemeList.data[0]);
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_ThemePage_Action>({
      type: 'nodeManagerPage/onUnmount_ThemePage',
    });
  });

  const { run } = AHooks.useDebounceFn(
    () => {
      dispatch<OnChangeThemeAction>({
        type: 'nodeManagerPage/onChangeTheme',
        payload: {
          themeInputFilter: themeInputFilter,
        },
      });
    },
    {
      wait: 300,
    },
  );

  /** 跳转资源详情页 */
  const toResourceDetail = (id: string) => {
    window.open(FUtil.LinkTo.resourceDetails({ resourceID: id }));
  };

  /** 浏览更多主题 */
  const viewMoreTheme = () => {
    history.push(FUtil.LinkTo.market({ query: '主题' }));
  };

  /** 激活主题 */
  const activeTheme = async (theme: {
    resourceId: string;
    latestVersion: string;
    resourceName: string;
    resourceTitle: string;
    policies: {
      policyId: string;
      policyName: string;
      status: 0 | 1;
    }[];
  }) => {
    if (activeId) return;

    setActiveId(theme.resourceId);

    // const params: Parameters<typeof FServiceAPI.Exhibit.createPresentable>[0] = {
    // console.log(theme, 'theme asedi8fujl;skdjflkjdslkfjlksjdlk');
    const params: Parameters<typeof FServiceAPI.Exhibit.createPresentable>[0] = {
      nodeId: Number(id),
      resourceId: theme.resourceId,
      version: theme.latestVersion,
      batchSignContracts: [
        {
          resourceId: theme.resourceId,
          subjectType: 1,
          policyIds: theme.policies.filter((p) => p.status === 1).map((p) => p.policyId),
        },
      ],
      presentableName: theme.resourceName.split('/')[1],
      presentableTitle: theme.resourceTitle,
      policies: [
        {
          policyName: '开放授权',
          policyText: 'for public initial[active]:\n  terminate',
          status: 1,
        },
      ],
    };

    // console.log(params, 'params isdjf;lksdjfl;kjsdlkjflksdjlkjl');
    let result = await FServiceAPI.Exhibit.createPresentable(params);

    if (result.errCode !== 0) {
      fMessage('激活失败', 'error');
      setActiveId(null);
      return;
    }

    const activeParams: Parameters<typeof FServiceAPI.Exhibit.presentablesOnlineStatus>[0] = {
      presentableId: result.data.presentableId,
      onlineStatus: 1,
    };
    result = await FServiceAPI.Exhibit.presentablesOnlineStatus(activeParams);

    if (result.errCode !== 0) {
      fMessage('激活失败', 'error');
      setActiveId(null);
      return;
    }

    setActiveId(null);
    setEmptyPopupShow(false);
    fMessage('激活成功', 'success');
    dispatch<FetchThemesAction>({
      type: 'nodeManagerPage/fetchThemes',
    });
    dispatch<OnMount_Page_Action>({
      type: 'nodeManagerPage/onMount_Page',
      payload: {
        nodeID: Number(id),
        showPage: 'theme',
      },
    });
  };

  /** 开关占位主题弹窗 */
  // const operateEmptyPopup = () => {
  //   setEmptyPopupShow(!emptyPopupShow);
  // };

  return (
    <>
      <Helmet>
        <title>{`主题管理 · ${nodeManagerPage.nodeTitle || nodeManagerPage.nodeName} - Freelog`}</title>
      </Helmet>
      {/* <FLeftSiderLayout
        sider={<Sider />}
        type='empty'
      > */}
      <div className={styles.pageScrollPadding}>
        <div className={styles.wrapper}>
          {nodeManagerPage.theme_ListState === 'noData' ? (
            <RecommendThemes
              nodeID={Number(id)}
              btn='more'
              onSuccess={() => {
                dispatch<FetchThemesAction>({
                  type: 'nodeManagerPage/fetchThemes',
                });
                dispatch<OnMount_Page_Action>({
                  type: 'nodeManagerPage/onMount_Page',
                  payload: {
                    nodeID: Number(id),
                    showPage: 'theme',
                  },
                });
              }}
            />
          ) : (
        <>
          <div className={styles.header}>
            <FComponentsLib.FTitleText
              type='h1'
              text={
                // 主题管理
                FI18n.i18nNext.tAuto('nodemgnt_managethemes_title')
              }
            />
            <FInput_Search
              value={themeInputFilter}
              className={styles.input}
              onChange={(e) => {
                setThemeInputFilter(e.target.value);
                run();
              }}
              placeholder={FI18n.i18nNext.t('nodemngt_theme_search_hint')}
            />
          </div>
          {nodeManagerPage.theme_ListState === 'loading' && (
            <FLoadingTip height={'calc(100vh - 270px)'} />
          )}
          {nodeManagerPage.theme_ListState === 'noSearchResult' && (
            <FNoDataTip height={'calc(100vh - 270px)'} tipText={'无搜索结果'} />
          )}
          {nodeManagerPage.theme_ListState === 'loaded' && (
            <div className={styles.body}>
              {nodeManagerPage.theme_List.map((i) => {
                const hasActiveBtn: boolean = !i.isOnline;
                return (
                  <div className={styles.theme} key={i.id}>
                    <div className={styles.cover}>
                      <Space size={10}>
                        {i.isOnline && (
                          <label className={styles.label}>
                            {FI18n.i18nNext.tAuto('theme_state_active')}
                          </label>
                        )}

                        {!i.isAuth && (
                          <FTooltip title={i.authErrorText}>
                            <FIcons.FWarning />
                          </FTooltip>
                        )}
                      </Space>

                      <FCoverImage
                        src={i.cover || ''}
                        width='100%'
                        fit='contain'
                        className={styles.coverImage}
                        style={{ aspectRatio: 'auto', borderRadius: 0 }}
                      />

                      {nodeManagerPage.theme_ActivatingThemeID === i.id ? (
                        <div className={styles.processing}>
                          <span>{FI18n.i18nNext.tAuto('activatetheme_inprocessing')}</span>
                        </div>
                      ) : (
                        <div className={styles.action}>
                          <FCoverFooterButtons
                            buttons={[
                              {
                                type: hasActiveBtn ? 'active' : '',
                                async fn() {
                                  if (!i.isAuth) {
                                    // fMessage(F)
                                    fMessage(i.authErrorText, 'error');
                                    return;
                                  }
                                  if (!nodeManagerPage.nodeThemeId) {
                                    dispatch<OnActiveAction>({
                                      type: 'nodeManagerPage/onActive',
                                      payload: {
                                        id: i.id,
                                      },
                                    });
                                    return;
                                  }

                                  const res1: boolean = await fPromiseModalConfirm({
                                    title: '',
                                    description: FI18n.i18nNext.t('msg_change_theme_confirm', {
                                      ThemeName: i.title,
                                    }),
                                    okText: FI18n.i18nNext.t('btn_activate_theme'),
                                    cancelText: FI18n.i18nNext.t('keep_current_theme'),
                                  });

                                  if (!res1) {
                                    return;
                                  }

                                  dispatch<OnActiveAction>({
                                    type: 'nodeManagerPage/onActive',
                                    payload: {
                                      id: i.id,
                                    },
                                  });
                                },
                              },
                              {
                                type: 'edit',
                                fn() {
                                  window.open(FUtil.LinkTo.exhibitManagement({ exhibitID: i.id }));
                                },
                              },
                              {
                                type: 'resourceDetails',
                                fn() {
                                  window.open(
                                    FUtil.LinkTo.resourceDetails({ resourceID: i.resourceId }),
                                  );
                                },
                              },
                            ]}
                          />
                        </div>
                      )}
                    </div>
                    <div className={styles.meta}>
                      <FComponentsLib.FContentText text={i.title} singleRow type='highlight' />
                      <div className={styles.versionRow}>
                        <FComponentsLib.FContentText
                          type='additional1'
                          // text={`展示版本${i.version}`}
                          text={`${FI18n.i18nNext.tAuto('exhibit_entry_exhibitversion')} ${i.version}`}
                          singleRow={true}
                        />
                        {!i.autoUpdate && i.hasUpdateVersion === 'hasUpdate' && (
                          <FTooltip
                            title={
                              <div>
                                <FComponentsLib.FContentText
                                  type={'normal'}
                                  // text={'有更新。'}
                                  text={FI18n.i18nNext.tAuto(
                                    'nodemgnt_exhibitmgnt_updatesavailable_msg',
                                  )}
                                />
                                <div style={{ height: 10 }} />
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                  <FComponentsLib.FTextBtn
                                    type={'primary'}
                                    style={{ fontSize: 12 }}
                                    onClick={async () => {
                                      const { ret, errCode, msg } =
                                        await FServiceAPI.Exhibit.presentablesVersion({
                                          presentableId: i.id,
                                          version: i.resourceLatestVersion,
                                        });
                                      if (ret !== 0 || errCode !== 0) {
                                        fMessage(msg, 'error');
                                        return;
                                      }
                                      await dispatch<ChangeAction>({
                                        type: 'nodeManagerPage/change',
                                        payload: {
                                          theme_List: nodeManagerPage.theme_List.map((e) => {
                                            if (e.id !== i.id) {
                                              return e;
                                            }
                                            return {
                                              ...e,
                                              hasUpdateVersion: 'noUpdate',
                                              version: e.resourceLatestVersion,
                                            };
                                          }),
                                        },
                                      });
                                    }}
                                  >
                                    {/*更新*/}
                                    {FI18n.i18nNext.tAuto(
                                      'nodemgnt_exhibitmgnt_updatesavailable_btn_update',
                                    )}
                                  </FComponentsLib.FTextBtn>
                                  <FComponentsLib.FTextBtn
                                    type={'primary'}
                                    style={{ fontSize: 12 }}
                                    onClick={() => {
                                      self.open(
                                        // i.collection
                                        0 !== 0
                                          ? FUtil.LinkTo.collectionDetails({
                                              collectionID: i.resourceId,
                                            })
                                          : FUtil.LinkTo.resourceDetails({
                                              resourceID: i.resourceId,
                                            }),
                                      );

                                      // + '?showMoreSetting=true'
                                    }}
                                  >
                                    {/*查看更新内容*/}
                                    {FI18n.i18nNext.tAuto(
                                      'nodemgnt_exhibitmgnt_updatesavailable_btn_viewdetails',
                                    )}
                                  </FComponentsLib.FTextBtn>
                                  <FComponentsLib.FTextBtn
                                    type={'default'}
                                    style={{ fontSize: 12, color: '#999' }}
                                    onClick={async () => {
                                      const { ret, errCode, msg } =
                                        await FServiceAPI.Exhibit.ignorePresentableVersionUpdateTip(
                                          {
                                            presentableId: i.id,
                                            ignoreVersion: i.resourceLatestVersion,
                                          },
                                        );

                                      if (ret !== 0 || errCode !== 0) {
                                        fMessage(msg, 'error');
                                        return;
                                      }

                                      await dispatch<ChangeAction>({
                                        type: 'nodeManagerPage/change',
                                        payload: {
                                          theme_List: nodeManagerPage.theme_List.map((e) => {
                                            if (e.id !== i.id) {
                                              return e;
                                            }
                                            return {
                                              ...e,
                                              hasUpdateVersion: 'ignored',
                                            };
                                          }),
                                        },
                                      });
                                    }}
                                  >
                                    {/*忽略*/}
                                    {FI18n.i18nNext.tAuto(
                                      'nodemgnt_exhibitmgnt_updatesavailable_btn_ingore',
                                    )}
                                  </FComponentsLib.FTextBtn>
                                </div>
                              </div>
                            }
                          >
                            <FIcons.FUpdateVersion
                              style={{
                                color: '#42C28C',
                                fontSize: 20,
                                lineHeight: '20px',
                                cursor: 'pointer',
                              }}
                            />
                          </FTooltip>
                        )}
                      </div>
                    </div>
                    <div className={styles.bottom}>
                      <div className={styles.polices}>
                        {i.policies.length > 0 ? (
                          <FComponentsLib.F_Contract_And_Policy_Labels
                            data={i.policies.map((p) => {
                              return {
                                text: p,
                                dot: '',
                              };
                            })}
                          />
                        ) : (
                          <FComponentsLib.FContentText
                            text={
                              // 暂无策略…
                              FI18n.i18nNext.tAuto('exhibit_entry_authplan_emtry')
                            }
                            type='additional2'
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
          )}
        </div>
      </div>
      {/* </FLeftSiderLayout> */}
    </>
  );
}

export default connect(({ nodeManagerPage }: ConnectState) => ({
  nodeManagerPage,
}))(Themes);
